import React from 'react'
import { Skeleton, useTheme } from '@mui/material'
import { Grid, Box } from '../../../../../components/mui/Core/index'

function ReportsLoadingSkeleton() {
  const theme = useTheme()

  const subHeaderContainerStyle = { mt: 4 }
  const cardContainerStyle = {
    minHeight: '89px',
    minWidth: '496px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '12px',
    justifyContent: 'space-between',
    padding: '15px 10px 15px 24px',
    border: '1px solid #e5e5e5',
    backgroundColor: theme.palette.background.paper,
  }
  return (
    <Grid container size={{ xs: 12 }} spacing={4}>
      <Grid size={{ xs: 12 }} sx={subHeaderContainerStyle}>
        <Skeleton variant='text' width={150} height={40} />
      </Grid>

      <Grid container spacing={2}>
        {[1, 2, 3, 4, 5].map((val) => (
          <Box sx={cardContainerStyle} key={`reports-loading-skeleton-${val}`}>
            <Box sx={{ width: '100%' }}>
              <Skeleton variant='text' width='60%' height={28} />

              <Skeleton variant='text' width='40%' height={20} />
            </Box>

            <Skeleton variant='circular' width={28} height={28} />
          </Box>
        ))}
      </Grid>
    </Grid>
  )
}

export default ReportsLoadingSkeleton
